export default __webpack_public_path__ + "static/media/ellipse-bottom-right.a6396d17.svg";